import React from "react";

export default function Tagline(){
    return(
        <div className="tagline bg-slate-900">
            <div className="container relative">                
                <div className="grid grid-cols-1">
                    <div className="text-center">
                        <h6 className="text-white font-medium">Refer a friend & get $50 in credits each 🎉</h6>
                    </div>
                </div>
            </div>
        </div>
    )
}
